export default __webpack_public_path__ + "static/media/two-eyes.f409dbec.md";